import MyQuizzes from '../views/MyQuizzes';

const router = [
  {
    name: 'myQuizzes',
    path: '/my-quizzes',
    component: MyQuizzes,
    meta: {
      requiresAuth: true,
      requiresTeacherRole: true,
    },
  },
];

export default router;



// WEBPACK FOOTER //
// ./src/app/my-quizzes/router/index.js